var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.cssClasses,attrs:{"to":_vm.route,"event":"never"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.onClicked.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }